/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Error_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Name is required" |
*
* @param {Tournament_New_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_error_name_required = /** @type {((inputs?: Tournament_New_Error_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Error_Name_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom est requis")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre es obligatorio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome é obrigatório")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome è obbligatorio")
	return /** @type {LocalizedString} */ ("Name is required")
});